import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'ui-booking-offer-link',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './offer-link.component.html',
  styleUrl: './offer-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferLinkComponent {
  @Input({ required: true }) offerNumber: string | undefined;
  @Output() offerLinkClicked = new EventEmitter<void>();

  @HostListener('click', ['$event.target'])
  addDownloadLinkListener(link: HTMLElement): void {
    if (link.classList.contains('offer-link-button-trigger')) {
      this.offerLinkClicked.emit();
    }
  }
}
